var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPisteet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 12,
    r: 6.5,
    fill: "#ffd11a",
    fillRule: "evenodd",
    strokeWidth: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9 4c-4.42 0-8 3.58-8 8 0 4.42 3.58 8 8 8 4.42 0 8-3.58 8-8 0-4.42-3.58-8-8-8zm0 2c3.31 0 6 2.69 6 6 0 3.31-2.69 6-6 6-3.31 0-6-2.69-6-6 0-3.31 2.69-6 6-6z",
    fill: "#b59100"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m7.8176 13.272v2.2277h-1.8176v-6.5h2.9899q1.3928 0 2.2101 0.58928 0.81737 0.58929 0.81737 1.5491 0 0.95982-0.81737 1.5491-0.81737 0.58482-2.2101 0.58482zm0-1.1607h1.1723q0.59152 0 0.90341-0.26786 0.31189-0.27232 0.31189-0.69643 0-0.43304-0.31189-0.70982-0.30652-0.27679-0.90341-0.27679h-1.1723z",
    fill: "#212121",
    strokeWidth: 1.8815,
    style: {
      shapeInside: "url(#rect307)",
      whiteSpace: "pre"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-.0019494 14.18)",
    d: "m16.6 8.3 0.6534-2.7334-2.1335-1.8294 2.8015-0.22325 1.0805-2.5944 1.0781 2.5954 2.8013 0.22593-2.1353 1.8273 0.65079 2.734-2.3977-1.4661z",
    fill: "#ffd11a",
    fillRule: "evenodd",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-.0019494 .080441)",
    d: "m16.6 8.3 0.6534-2.7334-2.1335-1.8294 2.8015-0.22325 1.0805-2.5944 1.0781 2.5954 2.8013 0.22593-2.1353 1.8273 0.65079 2.734-2.3977-1.4661z",
    fill: "#ffd11a",
    fillRule: "evenodd",
    strokeWidth: 0
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPisteet);
export default __webpack_public_path__ + "static/media/pisteet.f8897a5c14a22a132906611aec89ce8f.svg";
export { ForwardRef as ReactComponent };